import { render, staticRenderFns } from "./AddWhItem.vue?vue&type=template&id=0bae48ca&"
import script from "./AddWhItem.vue?vue&type=script&lang=js&"
export * from "./AddWhItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports